import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import AppBar from 'src/components/AppBar/AppBar';
import Footer from 'src/components/Footer';
import IdleTimerDialog from 'src/components/IdleTimerDialog';
import { useTabs } from 'src/hooks/useTabs';
import useTranslationSwitch from 'src/hooks/useTranslationSwitch';
import TabContentTemplate from '../TabContentTemplate';
import * as S from './InternalTemplate.styles';
const InternalTemplate = ({
  className,
  fullWidth,
  pageTitle,
  children,
  Prefooter,
  tabsConfig
}) => {
  const tabs = useTabs();
  const {
    t
  } = useTranslation();
  useTranslationSwitch({
    syncLang: true
  });
  const Main = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.ContentContainer, {
    withTabs: !!tabsConfig,
    fullWidth: fullWidth,
    className: className
  }, children), /*#__PURE__*/React.createElement(Footer, {
    Prefooter: Prefooter
  }));
  const Content = tabsConfig ? /*#__PURE__*/React.createElement(TabContentTemplate, {
    basePath: tabsConfig.path,
    tabs: tabs[tabsConfig.key]
  }, Main) : Main;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", null, pageTitle ? `${pageTitle} | ${t('b2c.head.title')}` : t('b2c.head.title'))), /*#__PURE__*/React.createElement(AppBar, null), Content, /*#__PURE__*/React.createElement(IdleTimerDialog, null));
};
export default InternalTemplate;